<template>
  <div>
    <!-- Navy hero -->
    <section
      class="w-full bg-mbzuai-navy-500 py-12 md:py-[42px] lg:py-21 background-pattern-navy-500--hero"
    >
      <ContentContainer>
        <h1 class="text-h1 font-normal text-mbzuai-sand-200">
          {{ $t('404 - Page not found') }}
        </h1>
      </ContentContainer>
    </section>

    <ContentContainer>
      <!-- Content -->
      <section class="w-full py-10 md:py-16">
        <NoResults
          class="flex flex-col items-center gap-8 md:gap-12 overflow-visible!"
        >
          <slot>
            <h2
              class="text-h2 font-normal text-mbzuai-dark-navy-500 leading-[1.2] max-w-4xl"
            >
              {{ $t('Sorry, the page you are looking for cannot be found.') }}
            </h2>

            <!-- Tips card -->
            <div
              class="bg-mbzuai-sand-100 rounded-lg p-6 md:p-10 w-full max-w-4xl"
            >
              <h3
                class="text-h3 font-normal text-mbzuai-dark-navy-500 leading-[1.2] mb-5"
              >
                {{ $t('Tips to get you back on track') }}
              </h3>
              <ul
                class="list-disc list-outside ps-5 text-body-small text-surface-500 flex flex-col gap-1.5 mb-8"
              >
                <li>
                  {{ $t('If you typed the web address, check it is correct.') }}
                </li>
                <li>
                  {{
                    $t(
                      'If you pasted the web address, check you copied the entire address.'
                    )
                  }}
                </li>
                <li>
                  {{ $t('Try browsing our') }}
                  <a href="/" class="underline text-mbzuai-navy-500">{{
                    $t('homepage')
                  }}</a
                  >.
                </li>
              </ul>

              <ParagraphSearchInputFormDefault
                :search-placeholder="$t('Enter a keyword')"
                custom-class="w-full"
              >
                <template #label>
                  <label
                    class="text-body-large-medium text-mbzuai-dark-navy-500"
                    for="search"
                  >
                    {{
                      $t('Or search the site to find the information you need.')
                    }}
                  </label>
                </template>
              </ParagraphSearchInputFormDefault>
            </div>
          </slot>
        </NoResults>
      </section>
    </ContentContainer>
  </div>
</template>

<script setup lang="ts">
import NoResults from '@/components/global/MBZ/NoResults.vue';
</script>
